import { FC } from 'react';
import { toNumberWithSpaces } from 'shared/lib/formatters';
import styles from './styles.module.scss';
import {pluralizeNoun} from "../../../../shared/lib/pluralizeNoun";

type InfoProps = {
  numberGoods: number;
  priceWithoutDiscount: number;
  orderWeight: number;
  promo?: number;
  sellerDiscount?: number;
};
export const InfoBlock: FC<InfoProps> = ({ numberGoods, priceWithoutDiscount, orderWeight, promo, sellerDiscount }) => {
  return (
    <ul className={styles.infoWrapper}>
      {Boolean(orderWeight) && (
        <li>
          <span>Вес заказа</span> <span>{orderWeight} кг</span>
        </li>
      )}
      <li>
        <span>
          {numberGoods} {pluralizeNoun(numberGoods, ['товар', 'товара', 'товаров'])} на сумму
        </span>
        <span>{toNumberWithSpaces(priceWithoutDiscount)} ₽</span>
      </li>
      {Boolean(sellerDiscount) && (
        <li>
          <span>Скидка продавца</span> <span className={styles.redText}>–{toNumberWithSpaces(sellerDiscount)} ₽</span>
        </li>
      )}
      {Boolean(promo) && (
        <li>
          <span>Скидка по промокоду</span> <span className={styles.redText}>–{toNumberWithSpaces(promo)} ₽</span>
        </li>
      )}
    </ul>
  );
};
